// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4a048c5d","239":"419f2078","732":"bdffe2f2"}[chunkId] + ".chunk.js";
};